import { render, staticRenderFns } from "./TournamentMain.vue?vue&type=template&id=43f9c2ef"
import script from "./TournamentMain.vue?vue&type=script&lang=js"
export * from "./TournamentMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports